import { render, staticRenderFns } from "./WhatsNewSave.vue?vue&type=template&id=1f11dbcd"
import script from "./WhatsNewSave.vue?vue&type=script&lang=js"
export * from "./WhatsNewSave.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewSave.vue?vue&type=style&index=0&id=1f11dbcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports